import React, { Component } from 'react';
import './DeskRules.scss'
import { Card,  Input, Button, Popconfirm, Alert } from 'antd'
import { getCaller, setConfiguration } from 'services/CeberusApiService'
import { ConfigurationRequest } from 'models/request/ConfigurationRequest'
import { JsonDocument } from 'models/Blip/Index'
import { Constants } from 'utils/constants'
import { PushNotification } from 'utils/PushNotification'
import { BaseRequest } from 'models/request/BaseRequest';

const { TextArea } = Input
const ALLOWED_AGENTS_DOMAINS_KEY = 'AllowedAgentsFromEmailDomains'

export class DeskAdminConfigs extends Component<BaseRequest> {

  state = {
    isLoading: false,
    AllowedAgentsFromEmailDomains: null,
    AllowedAgentsFromEmailDomainsSaved: null
  }

  componentDidMount() {
    this.loadConfigs()
  }

  async loadConfigs() {
    const allowedAgentsFromEmailDomains = await this.getDeskAdminConfig({
      identity: this.props.BotIdentifier
    })
    this.setState({ 
      AllowedAgentsFromEmailDomains: allowedAgentsFromEmailDomains,
      AllowedAgentsFromEmailDomainsSaved: allowedAgentsFromEmailDomains
    })
  }
  
  async SaveAllowedDomains() {
    let domain = this.state.AllowedAgentsFromEmailDomains
    if (domain) {
      domain = domain.replaceAll(' ', '')
    }
    try {
      const configurationRequest = new ConfigurationRequest();
      configurationRequest.Caller = Constants.ADMIN_CALLER
      configurationRequest.Owner = this.props.BotIdentifier
      configurationRequest.BotIdentifier = this.props.BotIdentifier
      configurationRequest.Resource = new JsonDocument(ALLOWED_AGENTS_DOMAINS_KEY, domain)
      var response = await setConfiguration(configurationRequest)
      PushNotification.success(response);
      this.setState({ 
        AllowedAgentsFromEmailDomains: domain,
        AllowedAgentsFromEmailDomainsSaved: domain  
      })
    }
    catch(error) {
      PushNotification.error(error);
    }
  }

  async getDeskAdminConfig({ identity }) {
    try {
      const configurationRequest = new ConfigurationRequest()
      configurationRequest.Caller = Constants.ADMIN_CALLER
      configurationRequest.BotIdentifier = identity
      configurationRequest.Owner = identity
      const { AllowedAgentsFromEmailDomains } = await getCaller(configurationRequest)
      return AllowedAgentsFromEmailDomains
    } catch (error) {
      return ''
    }
  }

  render() {
    return (
      <div>
        <Card>
          <Alert type="info" message="*If any domain configured, no one restriction will be applied"  showIcon />
          <div className="flex flex-column">
            <span>Domains allowed:</span>
            <TextArea 
              name="domains"
              rows={7}
              value={this.state.AllowedAgentsFromEmailDomains}
              onChange={event => this.setState({ AllowedAgentsFromEmailDomains: event.target.value })}
              placeholder="Inform domains allowed for add new agents"/>
          </div>
          <div className="flex justify-end mt2">
            <Popconfirm placement="right" disabled={this.state.AllowedAgentsFromEmailDomains == this.state.AllowedAgentsFromEmailDomainsSaved} 
              title="Are you sure to change allowed domains for new agents?" 
              onConfirm={() => this.SaveAllowedDomains()} 
              okText="Yes" cancelText="No"
            >
              <Button type="primary" disabled={this.state.AllowedAgentsFromEmailDomains == this.state.AllowedAgentsFromEmailDomainsSaved}>
                Save
              </Button>
            </Popconfirm>
          </div>          
        </Card>
      </div>
    )
  }
}